import { render, staticRenderFns } from "./FabricAttributeForm.vue?vue&type=template&id=8c63d222&scoped=true&"
import script from "./FabricAttributeForm.vue?vue&type=script&lang=js&"
export * from "./FabricAttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./FabricAttributeForm.vue?vue&type=style&index=0&id=8c63d222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c63d222",
  null
  
)

export default component.exports